import React, { JSX } from 'react';
import {
    Field,
    Image,
    ImageField,
    Link,
    LinkField,
    Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { StyleguideComponentProps } from 'lib/component-props';
import ArrowIcon from '../../assets/images/icons/arrow-right.svg';

type DescriptionItem = {
    id: string;
    fields: {
        Title: Field<string>;
        link: LinkField;
    };
};

type SistersFooterProps = StyleguideComponentProps & {
    fields: {
        Logo: ImageField;
        LogoLink: {
            value: {
                href: string;
            };
        };
        FooterDescription: Field<string>;
        CTA: LinkField;
        DescriptionLinks: Array<DescriptionItem>;
    };
};

const SistersFooter = (props: SistersFooterProps): JSX.Element | null => {
    const { fields } = props;
    if (!fields) return null;

    const { Logo, LogoLink, FooterDescription, CTA, DescriptionLinks } = fields;
    const year = new Date().getFullYear();

    return (
        <div className="overhauled" id={`sisters-footer-${props.rendering?.uid}`}>
            <div className="sisters-footer">
                <div className="sistersfooter-inner">
                    <div className="sistersfooter-container">
                        <div className="sistersfooter-logo">
                            <a
                                href={LogoLink?.value?.href || '#'}
                                className="sistersfooter-logo-link"
                            >
                                <Image field={Logo} />
                            </a>
                        </div>

                        <div className="sistersfooter-content">
                            {FooterDescription?.value && (
                                <Text
                                    tag="p"
                                    className="sistersfooter-description"
                                    field={FooterDescription}
                                />
                            )}
                            {CTA?.value?.href && (
                                <Link
                                    className="sistersfooter-cta"
                                    field={CTA}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="btn-tertiary sistersfooter-cta-text">
                                        {CTA.value.text || CTA.value.href}
                                    </span>
                                    <span className="sistersfooter-cta-icon" aria-hidden="true">
                                        <ArrowIcon />
                                    </span>
                                </Link>
                            )}
                        </div>
                    </div>

                    <div className="sistersfooter-legal">
                        <span className="sistersfooter-copyright">
                            Copyright &copy; {year} OSF Healthcare System
                        </span>
                        <div className="sistersfooter-legal-links">
                            {DescriptionLinks?.map(({ id, fields }) =>
                                fields?.link?.value?.href ? (
                                    <div className="sistersfooter-legal-link" key={id}>
                                        <Link rel="noreferrer" field={fields.link} />
                                    </div>
                                ) : null
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={classNames('overhauled', 'sistersfooter-border', 'bg-primary-dark')}
                    aria-hidden="true"
                ></div>
            </div>
        </div>
    );
};

export default SistersFooter;